import { atom, useAtom } from "jotai";
import { RoofTypeFilterModel } from "../../clients/KompasApi";
import { Box, Text } from "@chakra-ui/react";
import { Multiselect } from "../Multiselect";

export const roofTypeIdsAtom = atom<number[]>([]);

interface Props {
  options: RoofTypeFilterModel[];
}

export function RoofTypeFilter({ options }: Props) {
  const [, setRoofTypeIds] = useAtom(roofTypeIdsAtom);

  if (!options.length) return null;

  return (
    <Box>
      <Text fontSize="sm" fontWeight="500">
        Dak type
      </Text>
      <Multiselect
        items={options}
        onChange={(v) => setRoofTypeIds(v.map((i) => i.id))}
        value={options.filter((o) => o.selected)}
      />
    </Box>
  );
}
